// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".noFlex[data-v-6094e220]{-webkit-box-flex:0!important;-ms-flex:none!important;flex:none!important}.max-height[data-v-6094e220]{max-height:400px}.ellipsify[data-v-6094e220]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}", ""]);
// Exports
module.exports = exports;
